import React, { useEffect } from 'react';
import { getLoginUrl } from 'app/shared/util/url-utils';
 
export const RedirectLogin = () => {
    useEffect(() => {
        window.location.href = getLoginUrl();
    }, []);
 
    return (null);
};
 
export default RedirectLogin;
